var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSavenew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 18,
    height: 18,
    fill: "url(#pattern0_3137_820)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_3137_820",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3137_820",
    transform: "scale(0.015625)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3137_820",
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAB2AAAAdgB+lymcgAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAJ0SURBVHic7Zs/axRBHIYfT0G9QqukEPxDwEIxsbAVcliLnyEqhFjrF7HXVuytbT2FaOMforGOxORMYe7SRYvdIbN7d9nZndl5T5kHBo65ud+8v+f2FhbmwJ0u8AR4DwyBPzM2hsA68Bg4W6MvJ64An2egSdfxCbgcqvkz/1jzZnwETlc1d8pBwCPgemnuC7Dl8NmYXKCY8wawBjz1LfyWotkV34It8oBi1jchig6sgpshCrbMd47yDqoWdxwKdq3Xuw1DxWTHet2duirHRcB/TRKgDqAmCVAHUJMEqAOoSQLUAdQkAeoAapIAdQA1SYA6gJokQB1ATRKgDqAmCVAHUJMEqAOoSQLUAdQkAeoAapIAdQA1SYA6gJokQB1ATRKgDqAmCVAHUONyUDI0HeAecBe4ms9tAq/ycSjIdCwHHJ2763vWWgA+MP1463q+xoe+Ve/AsxYQTsAisE31Gd/tfG1TagmIdQ9YBF4D86X5Q8Yv+fl8rY8EZ2IIMM3PWXMjsoPM54DzZAeyR9b7c0SUUIXPT+Aa8IPiJT4E7kxYexv4XVr7E1iquefM3APqNG8IIWEmBDRp3uArQS7Ap3mDjwSpgBDNG5pKkAkI2bxhkoRfwK1jPiMR0EbzhroSogtYIvuXRhvNG+pIiCogRvMGVwnRBMRs3uAiIbiAPavgRj53k/Hm94FeiA0r6OV72XvvkH0hJ4BvFOV486602QbFqyJm84Ye4xJGwNfSnO/jOwCrpaLl0fZlP41JP4fyeBhio5PAyykbDIDlEJs0ZJniHzvt8YIsexA6ZDb7ZPeELeAZcDHUBh5cAp6TZdojy3gfx0f9v6oVxW6Z6UeDAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavenew);
export default __webpack_public_path__ + "static/media/savenew.088975e295fbbf2eac43239e6441be94.svg";
export { ForwardRef as ReactComponent };